/* tslint:disable */
/* eslint-disable */
/**
 * Bfree API
 * API Documentation for B&Free Project
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    HostDevice,
    HostDeviceFromJSON,
    HostDeviceFromJSONTyped,
    HostDeviceToJSON,
} from './';

/**
 * 
 * @export
 * @interface HostDeviceDetail
 */
export interface HostDeviceDetail {
    /**
     * 
     * @type {HostDevice}
     * @memberof HostDeviceDetail
     */
    data?: HostDevice;
}

export function HostDeviceDetailFromJSON(json: any): HostDeviceDetail {
    return HostDeviceDetailFromJSONTyped(json, false);
}

export function HostDeviceDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): HostDeviceDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : HostDeviceFromJSON(json['data']),
    };
}

export function HostDeviceDetailToJSON(value?: HostDeviceDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': HostDeviceToJSON(value.data),
    };
}

